import { Alert, AlertIcon, Box, Flex, Progress, Stack, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutableModal from 'components/general/RoutableModal';
import { useUploadDocumentMutation } from 'generated/graphql';
import { useRef, useState } from 'react';
import { FileDrop } from 'react-file-drop';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { updateCacheOnUpload } from './lib';

function NewDocument() {
  const { clientId } = useParams() as { clientId: string };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const goBack = () => navigate('..');
  const inputRef = useRef<HTMLInputElement>(null);
  const [fileName, setNames] = useState('');
  const [file, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const documentType = searchParams.get('documentType') as string;
  const contractId = (searchParams.get('contractId') as string) || '';
  const [uploadDocumentMutation, { loading }] = useUploadDocumentMutation({
    update: updateCacheOnUpload(clientId),
    onCompleted: goBack,
  });

  const fileHandler = (files: any) => {
    const extension = files[0].name.split('.')[1]?.toLowerCase();
    const allowedExtension: string[] = ['doc', 'docx', 'pdf'];

    if (extension !== undefined && allowedExtension.includes(extension)) {
      setErrorMessage('');
      setNames(files[0].name);
      setFile(files[0]);
    } else {
      setNames('');
      setFile(null);
      setErrorMessage('File type not supported.');
    }
  };

  const filePicker = () => {
    if (inputRef.current != null) {
      inputRef.current.click();
    }
  };

  const handleSubmit = () => {
    if (fileName.length > 0) {
      uploadDocumentMutation({ variables: { clientId, type: documentType, contractId, file } });
    } else {
      setErrorMessage('Please select a file first.');
    }
  };

  return (
    <RoutableModal
      title="Upload Document"
      buttons={{ action: { text: 'Upload', handler: handleSubmit } }}
      loading={loading}
    >
      {!errorMessage.length && fileName.length > 0 && (
        <Flex mb={5}>
          <Box mr={3}>
            <FontAwesomeIcon icon={['fal', 'file-arrow-up']} size="3x" color="#A57EF3" />
          </Box>
          <Box flex={1}>
            <Text mb={1}>{fileName}</Text>
            <Stack>
              <Progress colorScheme="purple" size="sm" value={100} />
            </Stack>
          </Box>
        </Flex>
      )}
      {!!errorMessage.length && (
        <Stack mb={5}>
          <Alert status="error">
            <AlertIcon />
            {errorMessage}
          </Alert>
        </Stack>
      )}
      <Flex minHeight={150} align="center" border="2px" borderStyle="dashed" borderColor="gray.200">
        <Box flex={1} mt={8} textAlign="center" justifyItems="center" cursor="pointer">
          <FileDrop onTargetClick={filePicker} onDrop={f => fileHandler(f)}>
            <Text fontSize={12}>
              DRAG FILE HERE <br /> OR <br /> BROWSE
            </Text>
            <input
              value=""
              style={{ visibility: 'hidden', opacity: 0 }}
              ref={inputRef}
              type="file"
              onChange={e => fileHandler(e.target.files)}
            />
          </FileDrop>
        </Box>
      </Flex>
    </RoutableModal>
  );
}

export default NewDocument;
